/* eslint-disable no-sequences */
import React, { useContext, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_ACTIVE_USER } from "../../queries/auth.queries";
import { AccountContext } from "../../context/account.context";

const AppBootstrap = () => {
  const { accountState, setAccountState } = useContext(AccountContext);
  const { data: userData } = useQuery(GET_ACTIVE_USER);

  // Load shared config
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await fetch("/config/config.json");
        const sharedData = await response.json();

        setAccountState((prev) => ({
          ...prev,
          sharedData,
        }));
      } catch (err) {
        console.error("Failed to load config.json", err);
      }
    };

    loadConfig();
  }, [setAccountState]);

  // Store default shipping coordinates
  useEffect(() => {
    const addresses = userData?.activeCustomer?.addresses;

    if (!addresses?.length) return;

    const defaultAddress = addresses.find(
      (address) => address?.defaultShippingAddress === true,
    );

    if (defaultAddress?.longitude && defaultAddress?.latitude) {
      sessionStorage.setItem("longitude", defaultAddress.longitude);
      sessionStorage.setItem("latitude", defaultAddress.latitude);
    }
  }, [userData]);

  // Update page title
  useEffect(() => {
    document.title = accountState?.sharedData?.TITLE ?? "";
  }, [accountState?.sharedData?.TITLE]);

  return null;
};

export default AppBootstrap;
